export const bonus_revive_widget = {
	BONUS_REVIVE_WIDGET_TITLE: {
		value: 'REVIVE BONUS',
		config: {
			fill: '#CFDBB5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	BONUS_REVIVE_WIDGET_VALUE: {
		value: '$400',
		config: {
			fill: ['#92CF25', '#225A0F'],
			lineHeight: 1,
			fontFamily: 'Poppins SemiBold',
			fontSize: 42
		}
	}
};
